import React, { useMemo, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  FormGroup,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Tooltip,
  Typography,
  Box,
} from "@mui/material";
import { EditOutlined } from "@mui/icons-material";
import { useGlobalFilter, useSortBy, useTable } from "react-table";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import { GlobalFilter } from "../../components/GlobalFilter/GlobalFilter";
import { useLists } from "../../context/listContext";
import {
  toggleProductData,
  toggleProductFeatureData,
} from "../../api/products.api";
import { useAuth } from "../../context/authContext";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import { AntSwitch } from "../../styles/index.sty";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import { toggleProductSliderproduct } from "../../api/slider.api";
import PuffLoader from "react-spinners/PuffLoader";

const spinnerstyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

export const Products = () => {
  const navigate = useNavigate();
  const { config } = useAuth();
  const [slider_type, setSliderType] = useState("");
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [open2, setOpen2] = useState(false);
  const handleOpen2 = () => setOpen2(true);
  const [product, setProduct] = useState({});
  const handleClose2 = () => setOpen2(false);
  const {
    productsList,
    fetchProductsList,
    fetchProductConfigsList,
    sliderTypeList,
    fetchSliderTypeList,
  } = useLists();
  const data = useMemo(() => productsList, [productsList]);
  useEffect(() => {
    fetchProductsList();
    fetchProductConfigsList();
    fetchSliderTypeList("products");
  }, []);
  useEffect(() => {
    if (productsList.length > 0) {
      setLoading(false);
    }
  }, [productsList]);
  const [productData, setProductData] = useState({});
  const [limiter, setLimiter] = useState(20);
  const [loading, setLoading] = useState(true);
  // console.log(limiter + "limiter");
  // console.log(
  //   "this is the output",
  //   productsList[0]?.dimensions.split(/[ LHW*]+/)
  // );
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "45rem",
    bgcolor: "white",
    // border: "2px solid #000",
    borderRadius: "25px",
    boxShadow: 24,
    p: 2,
    padding: "2rem",
  };
  const handleSliderSelect = () => {
    setSliderType("");
    handleClose2();
  };
  const columns = useMemo(
    () => [
      {
        Header: "Product Name",
        accessor: "product_name",
      },
      // {
      //   Header: "Product Description",
      //   accessor: "product_description"
      // },
      {
        Header: "Product Price",
        accessor: "product_price",
      },
      {
        Header: "Product Offer Price",
        accessor: "product_offer_price",
      },
      {
        Header: "Dimensions",
        accessor: "dimensions",
      },
      {
        Header: "Stock",
        accessor: "stock",
      },
    ],
    []
  );

  // console.log("====", productData);

  const tableHooks = (hooks) => {
    hooks.visibleColumns.push((columns) => [
      {
        id: "Product Image",
        Header: "Product Image",
        Cell: ({ row }) => (
          <img
            src={row.original?.product_image_file}
            alt="product img"
            style={{ width: "10rem", aspectRatio: "1.5", margin: "auto" }}
          />
        ),
      },
      ...columns,
      {
        id: "Product Description",
        Header: "Product Description",
        Cell: ({ row }) => {
          return (
            <div className="flex justify-center">
              {row.original?.product_description.slice(0, limiter)}
              {limiter < 999 && (
                <button
                  onClick={() => {
                    setProductData(row.original);
                    console.log(productData);
                    handleOpen();
                  }}
                >
                  Read More
                </button>
              )}
            </div>
          );
        },
      },
      {
        id: "Category Bar Name",
        Header: "Category Bar Name",
        Cell: ({ row }) => {
          return (
            <div className="flex justify-center">
              {
                row.original?.["product-categories-bar"]
                  ?.product_category_bar_name
              }
            </div>
          );
        },
      },
      {
        id: "Category Name",
        Header: "Category Name",
        Cell: ({ row }) => {
          return (
            <div className="flex justify-center">
              {row.original?.["product-category"]?.product_category_name}
            </div>
          );
        },
      },
      {
        id: "Sub Category Name",
        Header: "Sub Category Name",
        Cell: ({ row }) => {
          return (
            <div className="flex justify-center">
              {
                row.original?.["product-sub-category"]
                  ?.product_sub_category_name
              }
            </div>
          );
        },
      },
      {
        id: "Reviews",
        Header: "Reviews",
        Cell: ({ row }) => {
          return (
            <div className="flex justify-center">
              {row.original?.["reviews"]?.length}{" "}
              {row.original?.["reviews"]?.length > 1 ? "reviews" : "review"}
            </div>
          );
        },
      },
      {
        id: "Featured",
        Header: "Featured",
        Cell: ({ row }) => {
          return (
            <div className="flex justify-center">
              <Tooltip
                title={`${row.is_featured ? "featured" : "non-featured"}`}
                onClick={() =>
                  toggleProductFeatureData(
                    { product_id: row.original.product_id },
                    config,
                    fetchProductsList
                  )
                }
              >
                <IconButton>
                  {" "}
                  <AntSwitch
                    checked={row.original.is_featured ? true : false}
                    inputProps={{ "aria-label": "ant design" }}
                  />
                </IconButton>
              </Tooltip>
            </div>
          );
        },
      },
      {
        id: "Product Configs",
        Header: "Product Configs",
        Cell: ({ row }) => {
          return (
            <div className="flex justify-center">
              <Tooltip
                title="Products Config"
                onClick={() => {
                  // console.log(row.id)
                  navigate("/product-configs", {
                    state: {
                      dataOg: row.original,
                    },
                  });
                }}
              >
                <IconButton>
                  <SettingsSuggestIcon
                    style={{ fontSize: "2rem", color: "#0a305e" }}
                  />
                </IconButton>
              </Tooltip>
            </div>
          );
        },
      },
      {
        id: "Product Slider",
        Header: "Product Slider",
        Cell: ({ row }) => {
          return (
            <div className="flex justify-center">
              <Tooltip
                title="Products Slider"
                onClick={() => {
                  console.log(row.original.product_id);
                  handleOpen2();
                  setProduct(row.original);
                  // navigate("/product-configs", {
                  //   state: {
                  //     dataOg: row.original,
                  //   },
                  // });
                }}
              >
                <IconButton>
                  <SettingsSuggestIcon
                    style={{ fontSize: "2rem", color: "#0a305e" }}
                  />
                </IconButton>
              </Tooltip>
            </div>
          );
        },
      },
      {
        id: "Actions",
        Header: "Actions",
        Cell: ({ row }) => {
          return (
            <div className="flex justify-center">
              <Tooltip
                title="Add Image"
                onClick={() => {
                  // console.log(row.id)
                  navigate("/product-image-gallery", {
                    state: {
                      data: row.original,
                    },
                  });
                }}
              >
                <IconButton>
                  <InsertPhotoIcon
                    style={{ fontSize: "2rem", color: "#0a305e" }}
                  />
                </IconButton>
              </Tooltip>
              <Tooltip
                title="Edit"
                onClick={() => {
                  // console.log(row.id)
                  navigate("/update-product", {
                    state: {
                      data: row.original,
                    },
                  });
                }}
              >
                <IconButton>
                  <EditOutlined
                    style={{ fontSize: "2rem", color: "#0a305e" }}
                  />
                </IconButton>
              </Tooltip>
              <Tooltip
                title={`${row.is_active ? "active" : "in-active"}`}
                onClick={() =>
                  toggleProductData(
                    { product_id: row.original.product_id },
                    config,
                    fetchProductsList
                  )
                }
              >
                <IconButton>
                  {" "}
                  <AntSwitch
                    checked={row.original.is_active ? true : false}
                    inputProps={{ "aria-label": "ant design" }}
                  />
                </IconButton>
              </Tooltip>
            </div>
          );
        },
      },
    ]);
  };

  const tableInstance = useTable(
    { columns, data },
    useGlobalFilter,
    tableHooks,
    useSortBy
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    preGlobalFilteredRows,
    setGlobalFilter,
    state,
  } = tableInstance;

  return (
    <>
      {loading ? (
        <Box sx={spinnerstyle}>
          <PuffLoader loading={loading} size={150} />
        </Box>
      ) : (
        <>
          <div className="flex justify-between w-[95%] m-auto mt-[5rem]">
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <Typography
                  id="modal-modal-description"
                  variant="h5"
                  component="h2"
                  sx={{ mt: 2, mb: 2 }}
                >
                  Product's Category{" "}
                  {productData["product-category"]?.product_category_name}
                </Typography>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  Product Name: {productData?.product_name}
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  Product Description: {productData?.product_description}
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  Product Price: {productData?.product_price}
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  Product Offer Price: {productData?.product_offer_price}
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  Product's Dimensions: {productData?.dimensions}
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  Product Stock: {productData?.stock}
                </Typography>
              </Box>
            </Modal>
            <Modal
              open={open2}
              onClose={handleClose2}
              aria-labelledby="modal-modal-title2"
              aria-describedby="modal-modal-description2"
            >
              <Box sx={style}>
                <FormGroup>
                  <InputLabel id="demo-simple-select-label">
                    Product Slider:
                  </InputLabel>
                  <Select
                    id="demo-simple-select"
                    value={slider_type}
                    style={{ textAlign: "left" }}
                    onChange={(e) => {
                      setSliderType(e.target.value);
                      toggleProductSliderproduct(
                        {
                          slider_id: e.target.value,
                          product_id: product.product_id,
                        },
                        config,
                        handleSliderSelect
                      );
                    }}
                  >
                    {sliderTypeList.map((type) => {
                      return (
                        <MenuItem value={type.slider_id} key={type.slider_id}>
                          {type.slider_name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormGroup>
              </Box>
            </Modal>
            <GlobalFilter
              preGlobalFilteredRows={preGlobalFilteredRows}
              setGlobalFilter={setGlobalFilter}
              globalFilter={state.globalFilter}
            />
            <Button
              type="button"
              variant="contained"
              // onClick={handleOpen}
              onClick={() => navigate("/add-product")}
            >
              Add New
            </Button>
          </div>
          <table {...getTableProps()} className="w-[95%] m-auto mt-10">
            <thead className="bg-[white]">
              {
                // Loop over the header rows
                headerGroups.map((headerGroup) => (
                  // Apply the header row props
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {
                      // Loop over the headers in each row
                      headerGroup.headers.map((column) => (
                        // Apply the header cell props
                        <th
                          {...column.getHeaderProps()}
                          className="border-4 p-3 bg-[#1976d2] text-white sticky top-0"
                        >
                          {
                            // Render the header
                            column.render("Header")
                          }
                        </th>
                      ))
                    }
                  </tr>
                ))
              }
            </thead>
            {/* Apply the table body props */}
            <tbody {...getTableBodyProps()}>
              {
                // Loop over the table rows
                rows.map((row, index) => {
                  // Prepare the row for display
                  prepareRow(row);
                  return (
                    // Apply the row props
                    <tr {...row.getRowProps()}>
                      {
                        // Loop over the rows cells
                        row.cells.map((cell) => {
                          // Apply the cell props
                          return (
                            //  <td {...cell.getCellProps()} className={`p-5 border-1px bg-blue-300 cursor-pointer`}>
                            <td
                              {...cell.getCellProps()}
                              className={`p-5 border-1px bg-${
                                !row.original.is_active
                                  ? "gray"
                                  : index % 2 === 0
                                  ? "white"
                                  : "blue-300"
                              } cursor-pointer text-center`}
                              style={{
                                background: !row.original.is_active
                                  ? "#b3b3b3"
                                  : null,
                              }}
                            >
                              {
                                // Render the cell contents
                                cell.render("Cell")
                              }
                            </td>
                          );
                        })
                      }
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </>
      )}
    </>
  );
};
